var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayoutsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8713 11.3564C15.5034 11.7155 15.2931 12.2324 15.3457 12.7843C15.4245 13.7304 16.2918 14.4225 17.2379 14.4225H18.9024V15.4649C18.9024 17.2783 17.4219 18.7588 15.6085 18.7588H5.55168C3.7383 18.7588 2.25781 17.2783 2.25781 15.4649V9.56927C2.25781 7.75589 3.7383 6.27539 5.55168 6.27539H15.6085C17.4219 6.27539 18.9024 7.75589 18.9024 9.56927V10.8308H17.1328C16.6422 10.8308 16.1954 11.0235 15.8713 11.3564Z",
    stroke: "#717C91",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25781 10.3578V6.35443C2.25781 5.31196 2.89731 4.38333 3.86971 4.01539L10.8254 1.3873C11.9117 0.97557 13.0768 1.78154 13.0768 2.94666V6.27557",
    stroke: "#717C91",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8292 11.7246V13.5292C19.8292 14.0111 19.4437 14.4052 18.9532 14.4228H17.2362C16.29 14.4228 15.4228 13.7307 15.3439 12.7846C15.2914 12.2327 15.5016 11.7158 15.8695 11.3567C16.1937 11.0238 16.6405 10.8311 17.131 10.8311H18.9532C19.4437 10.8486 19.8292 11.2428 19.8292 11.7246Z",
    stroke: "#717C91",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19531 9.99902H12.3275",
    stroke: "#717C91",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayoutsIcon);
export default __webpack_public_path__ + "static/media/payoutsIcon.0d1da414527d1f0640c327ebbf81f574.svg";
export { ForwardRef as ReactComponent };